<div stack-layout [fullHeight]="true" gap="md" paddingVertical="md">
  <div box-layout paddingHorizontal="md">
    <button
      text-button
      size="md"
      symbolLeft="chevron_left"
      variant="ghost"
      [routerLink]="['/locations/warehouses']"
    >
      Warehouse History
    </button>
  </div>

  @if (warehouse(); as warehouse) {
    <div center-layout paddingHorizontal="lg">
      <div
        grid-layout
        gap="md"
        [templateAreas]="gridLayout()"
        [templateColumns]="detailsGridTemplateColumns()"
        [fullWidth]="true"
      >
        <div
          box-layout
          gridArea="heading"
          elevation="raised"
          borderRadius="xs"
          padding="sm"
          color="secondary-surface"
          border="medium"
        >
          <div
            row-layout
            justifyContent="space-between"
            alignItems="center"
            wrap="wrap"
            gap="sm"
            paddingHorizontal="sm"
          >
            <div row-layout alignItems="center" gap="sm">
              <div>
                <Text role="title-large" color="on-background-variant">
                  {{ warehouse.name }}
                </Text>
              </div>
            </div>

            <div row-layout alignItems="center" gap="sm">
              <button
                text-button
                size="md"
                variant="ghost"
                [class]="headerActionButtonClassName"
                [routerLink]="['/locations/warehouses', warehouseCode, 'rma-config']"
              >
                RMA Config
              </button>

              @if (showCreateChildButton()) {
                <button
                  text-button
                  size="md"
                  variant="ghost"
                  [class]="headerActionButtonClassName"
                  (click)="openCreateChildDialog()"
                >
                  Create Child
                </button>
              }
            </div>
          </div>
        </div>

        <div
          box-layout
          gridArea="details"
          color="primary-surface"
          paddingVertical="md"
          paddingHorizontal="md"
          borderRadius="xs"
          border="medium"
          elevation="raised"
        >
          <div row-layout alignItems="center" gap="xs" paddingBottom="md">
            <Symbol name="article" />
            <Text role="headline-medium" color="on-background-variant">
              Warehouse Details
            </Text>
          </div>

          <div stack-layout [fullWidth]="true" gap="lg" paddingVertical="md">
            <div
              grid-layout
              [fullWidth]="true"
              templateColumns="repeat(auto-fit, minmax(310px, 1fr))"
              gap="lg"
            >
              <div stack-layout [grow]="1">
                <Text role="headline-small"> Code </Text>
                <app-input [form]="readonlyForm" controlName="code" />
              </div>

              <div stack-layout [grow]="1">
                <Text role="headline-small"> Name </Text>
                <app-input [form]="readonlyForm" controlName="name" />
              </div>

              <div stack-layout [grow]="1">
                <Text role="headline-small"> Active </Text>
                <app-input [form]="readonlyForm" controlName="active" />
              </div>

              <div stack-layout [grow]="1">
                <Text role="headline-small"> Entity </Text>
                <app-input [form]="readonlyForm" controlName="entity" />
              </div>         
 
              <div stack-layout [grow]="1">
                <Text role="headline-small"> DCC </Text>
                <app-input [form]="readonlyForm" controlName="dcc" />
              </div>

              <div stack-layout [grow]="1">
                <Text role="headline-small"> Currency </Text>
                <app-input [form]="readonlyForm" controlName="currency" />
              </div>

              <div stack-layout [grow]="1">
                <Text role="headline-small"> Non-Auction Sub-Inv. Code </Text>
                <app-input [form]="readonlyForm" controlName="nonAuctionSubInvCode" />
              </div>

              <div stack-layout [grow]="1">
                <Text role="headline-small"> WMS </Text>
                <app-input [form]="readonlyForm" controlName="wms" />
              </div>
           
              <div stack-layout [grow]="1">
                <Text role="headline-small"> Shipping Fee SKU </Text>
                <app-input [form]="readonlyForm" controlName="shippingFeeSku" />
              </div>

              <div stack-layout [grow]="1">
                <Text role="headline-small"> Auction Sub-Inv. Code </Text>
                <app-input [form]="readonlyForm" controlName="auctionSubInvCode" />
              </div>

              <div stack-layout [grow]="1">
                <Text role="headline-small"> Grading Code </Text>
                <app-input [form]="readonlyForm" controlName="gradingCode" />
              </div>

              @if (isChildWarehouse()) {
                <div stack-layout [grow]="1">
                  <Text role="headline-small"> Warehouse Inventory Code </Text>
                  <app-input [form]="readonlyForm" controlName="warehouseInventoryCode" />
                </div>
              } @else {
                <div></div>
              }
            </div>

            <div row-layout [fullWidth]="true" gap="lg" alignItems="start" wrap="wrap">
              <div stack-layout [grow]="1" gap="xs">
                <Text role="headline-small"> Shipping Options </Text>
                <div row-layout gap="md" wrapItems="wrap" alignItems="center">
                  @for (opt of shippingOptions(); track opt.value) {
                    <div row-layout alignItems="center" gap="xs">
                      <Symbol
                        [name]="
                          shippingOptionsSelections().includes(opt.value)
                            ? 'check_box'
                            : 'check_box_outline_blank'
                        "
                      />
                          <span [class]="shippingOptionLabelClassName">{{ opt.label }}</span>
                    </div>
                  }
                </div>
              </div>

              <div stack-layout [grow]="1" gap="xs">
                <Text role="headline-small"> Default Shipping Option </Text>
                <div row-layout gap="md" wrapItems="wrap" alignItems="center">
                  @for (opt of shippingOptions(); track opt.value) {
                    <div row-layout alignItems="center" gap="xs">
                      <Symbol
                        [name]="
                          warehouse.defaultShippingMethod === opt.value
                            ? 'radio_button_checked'
                            : 'radio_button_unchecked'
                        "
                      />
                          <span [class]="shippingOptionLabelClassName">{{ opt.label }}</span>
                    </div>
                  }
                </div>
              </div>
            </div>

            <div
              grid-layout
              [fullWidth]="true"
              templateColumns="repeat(auto-fit, minmax(280px, 1fr))"
              gap="lg"
            >
              <div stack-layout gap="xs">
                <Text role="headline-small"> Comments </Text>
                <form [formGroup]="readonlyForm">
                  <textarea
                    formControlName="comments"
                    rows="4"
                    [class]="commentsTextareaClassName"
                  ></textarea>
                </form>
              </div>
            </div>
          </div>
        </div>

        <div
          box-layout
          gridArea="inventory"
          color="primary-surface"
          borderRadius="xs"
          border="medium"
          elevation="raised"
          padding="sm"
        >
          <div
            row-layout
            justifyContent="space-between"
            alignItems="center"
            paddingHorizontal="sm"
            paddingBottom="sm"
          >
            <Text role="headline-medium" color="on-background-variant">
              Inventory Allocation Configuration
            </Text>

            <button
              text-button
              symbolLeft="save"
              size="md"
              variant="primary"
              [disabled]="isInventoryAllocationLoading || isInventoryAllocationSaving || !inventoryAllocationChannels.length || inventoryAllocationForm.invalid"
              (click)="saveInventoryAllocationConfiguration()"
            >
              Save
            </button>
          </div>

          @if (isInventoryAllocationLoading) {
            <div box-layout padding="sm" paddingHorizontal="md">
              <Text>Loading allocation configuration...</Text>
            </div>
          } @else if (inventoryAllocationChannels.length) {
            <div [class]="inventoryAllocationTableWrapperClassName">
              <table [class]="inventoryAllocationTableClassName">
                <thead>
                  <tr>
                    @for (channel of inventoryAllocationChannels; track channel.code) {
                      <th>
                        <Text role="headline-small" color="black">
                          {{ channel.name || channel.code }}
                        </Text>
                      </th>
                    }
                  </tr>
                </thead>

                <tbody>
                  <tr>
                    @for (channel of inventoryAllocationChannels; track channel.code) {
                      <td>
                        <app-input
                          [form]="inventoryAllocationForm"
                          [controlName]="inventoryAllocationControl(channel.code)"
                          type="text"
                        />
                      </td>
                    }
                  </tr>
                </tbody>
              </table>
            </div>

            @if (inventoryAllocationForm.errors?.['allocationSumExceeded']) {
              <div box-layout paddingTop="sm" paddingHorizontal="xs">
                <div row-layout alignItems="center" gap="xs">
                  <Symbol name="warning" color="error" />
                  <Text role="label" color="on-warn-container">
                    {{ allocationSumValidationMessage() }}
                  </Text>
                </div>
              </div>
            }
          } @else {
            <div box-layout padding="sm" paddingHorizontal="md">
              <Text>No inventory allocation configuration available.</Text>
            </div>
          }
        </div>

        @if (showRelationshipPanel()) {
          <div
            box-layout
            gridArea="relationship"
            color="primary-surface"
            borderRadius="xs"
            border="medium"
            elevation="raised"
            padding="sm"
          >
            @if (isChildWarehouse()) {
              <div stack-layout gap="xs">
                <Text role="headline-small" color="on-background-variant">
                  Parent warehouse
                </Text>

                <a
                  [routerLink]="['/locations/warehouses', warehouse.parentCode]"
                  [class]="relationshipLinkClassName"
                >
                  {{ parentWarehouse()?.name || warehouse.parentCode }}
                </a>
              </div>
            } @else {
              <div stack-layout gap="xs">
                <Text role="headline-small" color="on-background-variant">
                  Child Warehouses
                </Text>

                @if (childWarehouses().length) {
                  <div [class]="relationshipListClassName">
                    @for (child of childWarehouses(); track child.code) {
                      <a
                        [routerLink]="['/locations/warehouses', child.code]"
                        [class]="relationshipLinkClassName"
                      >
                        {{ child.name || child.code }}
                      </a>
                    }
                  </div>
                } @else {
                  <Text [class]="relationshipEmptyTextClassName">No child warehouses</Text>
                }
              </div>
            }
          </div>
        }
      </div>
    </div>
  }
</div>

<Dialog [show]="showCreateChildDialog()" (showing)="handleCreateChildDialogShow($event)">
  <DialogHeader>Create Child</DialogHeader>

  <div
    grid-layout
    templateColumns="1fr 1fr"
    gap="lg"
    padding="md"
    style="min-width: 520px"
  >
    <!-- Left column -->
    <div stack-layout gap="md">
      <div stack-layout gap="xs">
        <Text role="headline-small" color="on-primary-surface-variant">
          Child Warehouse Name
        </Text>
        <app-input
          [form]="createChildForm"
          controlName="childWarehouseName"
          [invalid]="
            createChildForm.controls['childWarehouseName'].invalid &&
            createChildForm.controls['childWarehouseName'].touched
          "
        />
      </div>

      <div stack-layout gap="xs">
        <Text role="headline-small" color="on-primary-surface-variant">
          Warehouse Inventory Code
        </Text>
        <app-input
          [form]="createChildForm"
          controlName="code"
          [invalid]="
            createChildForm.controls['code'].invalid &&
            createChildForm.controls['code'].touched
          "
        />
      </div>

      <div stack-layout gap="xs">
        <Text role="headline-small" color="on-primary-surface-variant">
          Currency
        </Text>
        <app-select
          [form]="createChildForm"
          controlName="currency"
          [options]="currencyOptions"
          placeholder="Select currency"
          [invalid]="
            createChildForm.controls['currency'].invalid &&
            createChildForm.controls['currency'].touched
          "
        ></app-select>
      </div>

      <div stack-layout gap="xs">
        <Text role="headline-small" color="on-primary-surface-variant">
          Order Consolidation Days
        </Text>
        <app-input
          [form]="createChildForm"
          controlName="orderConsolidationDays"
          type="text"
          [invalid]="
            createChildForm.controls['orderConsolidationDays'].invalid &&
            createChildForm.controls['orderConsolidationDays'].touched
          "
        />
      </div>
    </div>

    <!-- Right column -->
    <div stack-layout gap="md">
      <div stack-layout gap="xs">
        <Text role="headline-small" color="on-primary-surface-variant">
          Default Shipping Option
        </Text>
        <app-select
          [form]="createChildForm"
          controlName="defaultShippingOption"
          [options]="defaultShippingOptions"
          placeholder="Select default option"
        ></app-select>
      </div>

      <div stack-layout gap="xs">
        <Text role="headline-small" color="on-primary-surface-variant">
          Shipping Options
        </Text>
        <div stack-layout gap="xs">
          <app-checkbox
            [form]="createChildForm"
            controlName="assurantShipping"
            label="Assurant Shipping"
          />
          <app-checkbox
            [form]="createChildForm"
            controlName="schedulePickup"
            label="Schedule Pickup"
          />
          <app-checkbox
            [form]="createChildForm"
            controlName="shipFromMyAccount"
            label="Ship From My Account"
          />
        </div>
      </div>

      <div stack-layout gap="xs">
        <Text role="headline-small" color="on-primary-surface-variant">
          Auction Order Type
        </Text>
        <app-input
          [form]="createChildForm"
          controlName="auctionOrderType"
          [invalid]="
            createChildForm.controls['auctionOrderType'].invalid &&
            createChildForm.controls['auctionOrderType'].touched
          "
        />
      </div>

      <div stack-layout gap="xs">
        <Text role="headline-small" color="on-primary-surface-variant">
          Non Auction Order Types
        </Text>
        <app-input
          [form]="createChildForm"
          controlName="nonAuctionOrderTypes"
          [invalid]="
            createChildForm.controls['nonAuctionOrderTypes'].invalid &&
            createChildForm.controls['nonAuctionOrderTypes'].touched
          "
        />
      </div>
    </div>
  </div>

  <div row-layout justifyContent="center" gap="md" paddingBottom="md">
    <button
      text-button
      size="md"
      variant="warn"
      (click)="closeCreateChildDialog()"
    >
      Cancel
    </button>
    <button
      text-button
      size="md"
      variant="primary"
      [disabled]="isCreateChildSaving || createChildForm.invalid"
      (click)="saveCreateChild()"
    >
      Save
    </button>
  </div>
</Dialog>

